import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-white px-4 pb-3 pt-4" data-id="element-79" data-mp="9k0fha3kwjqp">
      <div className="mx-auto max-w-3xl text-center" data-id="element-80" data-mp="9ipc3be1pe04">
        <h1 className="mb-2 font-display text-[26px] uppercase leading-[0.95] tracking-wide text-brand-navy sm:text-5xl" data-id="element-81" data-mp="4mrul1r1q1lr">
          The Complete Ready-to-Use System for{' '}
          <span className="text-brand-blue" data-id="element-82" data-mp="xanq434vpngy">Volleyball Coaches</span>
        </h1>
        <p className="mx-auto mb-1 max-w-2xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-83" data-mp="x8jj3cboo8cg">
          Stop losing hours every week planning practices, searching for drills, building
          progressions, and trying to turn match problems into effective training sessions.
        </p>
        <p className="mx-auto mb-2 max-w-2xl text-[13px] font-semibold leading-snug text-brand-navy sm:text-base" data-id="element-84" data-mp="382fhvvzgliim">
          Finally, everything you need is organized into one practical, professional coaching
          system.
        </p>

        <a href={OFFER_ANCHOR} className="mb-2 block" aria-label="Go to the purchase section" data-id="element-85" data-mp="3o6kd5bieo01y">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[280px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-sm" data-id="element-86" data-mp="399bbnoze1fwi" />
        </a>

        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-87" data-mp="358reiletecad">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-navy sm:text-sm" data-id="element-88" data-mp="35akitu1ygkf7">
          <span className="flex items-center gap-1" data-id="element-89" data-mp="2vi50uwqnrvub">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-90" data-mp="2vglkz78wzmt2" />
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </span>
          <span className="flex items-center gap-1" data-id="element-91" data-mp="2ljh0rcymq1ew">
            <ShieldCheckIcon className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-92" data-mp="s1rr4kwyw0sp" />
            🛡️ 14-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}